module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error"
  }, [_c('h1', [_vm._v("ERROR 404! Página no encontrada")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v(" Ir a inicio ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be98556c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
// module id = 456
// module chunks = 1